<script setup lang="ts">
defineProps<{
  src: string
  title: string
  alt: string
  description: string
}>();
</script>

<template>
  <article class="rounded-xl bg-white overflow-clip relative border border-neutral-70 isolate">
    <figure>
      <img
        :src
        :alt
        loading="lazy"
        class="w-full aspect-[4/3] object-cover"
      >
    </figure>
    <div class="px-m pt-l pb-s">
      <IadTitle
        :text="title"
        variant="small-semibold"
        class="text-secondary"
        tag="h3"
      />
      <p v-text="description" />
    </div>
  </article>
</template>
